import React from 'react';
import './LocationSection.css';
import { Button, useScrollAnimation } from '../shared';
import { useLanguage } from '../../contexts/LanguageContext';
import { ReactComponent as NordenMap } from '../../assets/Norden.svg';

/**
 * Location Section component
 * Displays the Northern Germany map with Kiel and Hamburg locations
 * Includes scroll-triggered floating animation for accessibility-friendly reveal effect
 *
 * @param {function} onNavigateToBetaTest - Callback to navigate to beta test page
 */
const LocationSection = ({ onNavigateToBetaTest }) => {
  const { t } = useLanguage();

  // Use shared scroll animation hook - re-triggers on each scroll into viewport
  const { ref: sectionRef, isVisible } = useScrollAnimation({
    rootMargin: '-100px 0px',
    threshold: 0.1,
    delay: 100
  });

  const handleBetaClick = () => {
    if (onNavigateToBetaTest) {
      onNavigateToBetaTest();
    }
  };

  const sectionClasses = [
    'location-section',
    isVisible ? 'is-visible' : ''
  ].filter(Boolean).join(' ');

  return (
    <section
      ref={sectionRef}
      className={sectionClasses}
      id="location"
      aria-labelledby="location-heading"
    >
      <div className="location-section-container">
        {/* Map Graphic */}
        <div
          className="location-section-map"
          role="img"
          aria-label={t('a11y.locationMapAlt')}
        >
          <NordenMap className="location-map-svg" aria-hidden="true" />
        </div>

        {/* Content */}
        <div className="location-section-content">
          <div className="location-section-text-block">
            {/* Title with highlighted part */}
            <h2 id="location-heading" className="location-section-title">
              {t('location.title.start')}
              <span className="location-section-title-highlight">
                {t('location.title.highlight')}
              </span>
              {t('location.title.end')}
            </h2>

            {/* Description */}
            <p className="location-section-description">
              {t('location.description')}
            </p>
          </div>

          {/* CTA Button */}
          <Button
            variant="primary"
            size="large"
            ariaLabel={t('a11y.betaButtonLabel')}
            onClick={handleBetaClick}
          >
            {t('location.ctaButton')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
